import gql from 'graphql-tag';

export const linkAssetsActionCenter = gql`
	mutation linkAssetsObjects(
		$assets: [UUID]!
		$classifications: [String]
		$files: [UUID]
		$incidents: [UUID]
		$location: UUID
		$requests: [UUID]
		$workOrders: [UUID]
		$labels: [UUID]
	) {
		linkAssetsObjects(
			assets: $assets
			classifications: $classifications
			files: $files
			incidents: $incidents
			location: $location
			requests: $requests
			workOrders: $workOrders
			labels: $labels
		) {
			success
		}
	}
`;

export const linkWorkOrdersActionCenter = gql`
	mutation linkWorkOrders(
		$workOrders: [UUID]!
		$approver: UUID
		$approverType: UserGroupEnum
		$assets: [AssetInput]
		$assignee: UUID
		$assigneeType: UserGroupEnum
		$category: WorkOrderCategories
		$deadline: DateTime
		$files: [UUID]
		$incidents: [UUID]
		$locations: [LocationInput]
		$priority: Int
		$requests: [UUID]
		$routineData: InputRoutineType
		$status: WorkOrderStatus
	) {
		linkWorkOrders(
			workOrders: $workOrders
			approver: $approver
			approverType: $approverType
			assets: $assets
			assignee: $assignee
			assigneeType: $assigneeType
			category: $category
			deadline: $deadline
			files: $files
			incidents: $incidents
			locations: $locations
			priority: $priority
			requests: $requests
			routineData: $routineData
			status: $status
		) {
			success
		}
	}
`;

export const linkLabelsActionCenter = gql`
	mutation labelEntities(
		$labelIds: [UUID]!
		$fileIds: [UUID]
		$incidentIds: [UUID]
		$requestIds: [UUID]
		$workOrderIds: [UUID]
	) {
		labelEntities(
			labelIds: $labelIds
			fileIds: $fileIds
			incidentIds: $incidentIds
			requestIds: $requestIds
			workOrderIds: $workOrderIds
		) {
			success
		}
	}
`;

export const batchUpdateConditionGrades = gql`
	mutation batchUpdateConditionGrades(
		$assets: [UUID]!
		$conditionGrade: Int
		$conditionGradeNote: String
	) {
		batchUpdateAssets(
			assets: $assets
			conditionGrade: $conditionGrade
			conditionGradeNote: $conditionGradeNote
		) {
			success
		}
	}
`;
